/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Field_Message_PlaceholderInputs */

const en_contact_field_message_placeholder = /** @type {(inputs: Contact_Field_Message_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coverage and desks, roughly how much research you publish, and any timelines we should know about.`)
};

/**
* | output |
* | --- |
* | "Coverage and desks, roughly how much research you publish, and any timelines we should know about." |
*
* @param {Contact_Field_Message_PlaceholderInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const contact_field_message_placeholder = /** @type {((inputs?: Contact_Field_Message_PlaceholderInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Field_Message_PlaceholderInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_contact_field_message_placeholder(inputs)
});